// extracted by mini-css-extract-plugin
var _1 = "Content_container__MgHe0";
var _2 = "Content_loader__mlqki";
export { _1 as "container", _2 as "loader" }
